// Module
var code = `<template> <div class="page-video animation-page-slide-bottom"> <div class="video-header"> <h1 class="title">\${productName}</h1> </div> <div class="video-body"> <div class="video-container"> <iframe src="\${youtubeUrl}" allowfullscreen></iframe> </div> </div> </div> </template>`;
// Exports
module.exports = code;